import { Component } from 'react';
import I18n from 'I18n';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UISelect from 'UIComponents/input/UISelect';
import { DEFAULT_BRANCH_INDEX } from 'automation-ui-action-features/records/recordsUtils';
import StaticBranchName from 'automation-ui-action-features/actions/static-branch/StaticBranchName';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Text } from 'foundations-components/components/Text';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { List } from 'foundations-components/transitional/components/List';
import { RadioInput } from 'foundations-components/transitional/components/RadioInput';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Button } from 'foundations-components/transitional/components/Button';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class InsertOrRemoveBranchModal extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      removeAllChildren: false,
      // we need to effectively not pass a value for branchIndexToKeep when a branch is not selected
      branchIndexToKeep: undefined
    };
    this.handleSave = () => {
      return this.props.onSave(this.state);
    };
    this.setRemoveAllChildren = () => {
      this.setState({
        removeAllChildren: true,
        branchIndexToKeep: undefined
      });
    };
    this.getBranchName = (branch, branchIndex) => {
      const {
        action,
        previousActionId,
        flowObjectTypeId,
        getActionOutputsForTargetActionById
      } = this.props;
      if (action && action.isStaticBranch()) {
        return /*#__PURE__*/_jsx(StaticBranchName, {
          action: action,
          previousActionId: previousActionId,
          branch: branch,
          branchIndex: branchIndex,
          propertyTypeId: flowObjectTypeId,
          getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
        });
      }
      const defaultValue = I18n.text('action-features.list-branch.branch-label.default', {
        branchNumber: branchIndex + 1
      });
      const branchName = branch.getBranchName() || defaultValue;
      return branchName;
    };
    this.handleOnBranchChange = ({
      target: {
        value
      }
    }) => {
      this.setState({
        removeAllChildren: false,
        branchIndexToKeep: value
      });
    };
  }
  getBranchNameOptions() {
    const {
      stagedChanges: {
        defaultBranchName,
        branches
      },
      hideDefaultBranch
    } = this.props;
    const defaultBranchOption = {
      text: defaultBranchName || I18n.text('action-features.list-branch.branch-label.otherwiseDefaultBranchName'),
      value: DEFAULT_BRANCH_INDEX
    };
    const branchOptions = branches.map((branch, branchIndex) => ({
      text: this.getBranchName(branch, branchIndex),
      value: branchIndex
    })).toJS();
    return hideDefaultBranch ? branchOptions : [...branchOptions, defaultBranchOption];
  }
  render() {
    const {
      onClose,
      langKeyPath,
      hideDefaultBranch
    } = this.props;
    const {
      removeAllChildren,
      branchIndexToKeep
    } = this.state;
    const defaultValue = hideDefaultBranch ? 0 : -1;
    return /*#__PURE__*/_jsxs(Modal, {
      width: 550,
      "data-test-id": "insert-or-remove-branch-modal",
      children: [/*#__PURE__*/_jsxs(DialogHeader, {
        children: [/*#__PURE__*/_jsx(DialogCloseButton, {
          onClick: onClose
        }), /*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${langKeyPath}.header`
          })
        })]
      }), /*#__PURE__*/_jsxs(DialogBody, {
        children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `${langKeyPath}.optionsPrompt`
        }), /*#__PURE__*/_jsxs(List, {
          marginBlockStart: "200",
          children: [/*#__PURE__*/_jsx(RadioInput, {
            checked: removeAllChildren,
            name: "branch-type",
            onChange: this.setRemoveAllChildren,
            "data-test-id": "remove-branch-all",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `${langKeyPath}.removeAll`
            })
          }), /*#__PURE__*/_jsxs(RadioInput, {
            checked: branchIndexToKeep !== undefined,
            name: "branch-select",
            onChange: () => this.handleOnBranchChange(syntheticEvent(defaultValue)),
            children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: `${langKeyPath}.executeABranch`
            }), /*#__PURE__*/_jsx(UISelect, {
              value: branchIndexToKeep,
              options: this.getBranchNameOptions(),
              placeholder: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
                message: `${langKeyPath}.placeholderBranchName`
              }),
              onChange: this.handleOnBranchChange,
              className: "m-top-2"
            })]
          })]
        })]
      }), /*#__PURE__*/_jsxs(DialogFooter, {
        children: [/*#__PURE__*/_jsx(Button, {
          use: "primary",
          type: "submit",
          disabled: !(removeAllChildren || branchIndexToKeep !== undefined),
          onClick: this.handleSave,
          "data-test-id": "remove-branch-ok",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `${langKeyPath}.removeButton`
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "secondary",
          type: "submit",
          onClick: onClose,
          "data-test-id": "remove-branch-cancel",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "edit.cancel"
          })
        })]
      })]
    });
  }
}
export default InsertOrRemoveBranchModal;